import {Component, OnInit} from '@angular/core';
import {ApiClhubService} from '../_services/apiClhub.service';
import {KeycloakService} from 'keycloak-angular';
import {PowerBiObjectModel} from '../_models/DAL/PowerBiObject.model';
import {AuthenticationService} from '../_services/authentication.service';
import {Router} from '@angular/router';
import {MicrosoftGraphService} from '../_services/microsoftGraph.service';
import {User} from '../_models/user.model';
import {Observable} from 'rxjs';
import {filter, take} from 'rxjs/operators';
import {UserOrGroupModel} from '../_models/DAL/UserOrGroup.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent  implements OnInit  {

  public Reports: PowerBiObjectModel[] = [];
  public Dashboards: PowerBiObjectModel[] = [];
  private currentUser: User;
  private currentUserSubscribe: Observable<any>;

  constructor(private CLHUBAPI: ApiClhubService,
              private keycloakService: KeycloakService,
              private authenticationService: AuthenticationService,
              private router: Router,
              private AzureService: MicrosoftGraphService) {


    this.AzureService.GraphClientSubject.subscribe((client) => {
      if (client !== undefined) {
        client.api('https://graph.microsoft.com/v1.0/me/memberOf').get()
          .then( memberOf => {
            const listOfGroupsId = [];
            for (const group of memberOf.value) {
              listOfGroupsId.push(group.id);
            }
            this.currentUser = this.authenticationService.currentUserValue;
            this.currentUser.groupsid = [];
            this.currentUser.groupsid = listOfGroupsId;
          });
      }
    });
  }

  ngOnInit(): void {

    this.authenticationService.currentUser.pipe(filter(result => result != null))
      .pipe(filter(result => result.azure_id != null))
      .pipe(take(1))
      .subscribe((user) => {

      if (this.currentUser == null) {
        this.currentUser = user;
      }



      this.CLHUBAPI.post('UserOrGroup/filtered-list', {'AzureObjectId': this.currentUser.azure_id})
        .subscribe((currentUser) => {
          if (currentUser.length > 0) {

            this.currentUser.userOrGroupId = currentUser[0].id;

            let updateRequired = false;
            // Mise à jour du User si besoin
            if (currentUser[0].userMail !== this.authenticationService.currentUserValue.email) { updateRequired = true; }
            if (currentUser[0].userGivenName !== this.authenticationService.currentUserValue.given_name) { updateRequired = true; }
            if (currentUser[0].userSurname !== this.authenticationService.currentUserValue.family_name) { updateRequired = true; }


            if (updateRequired) {
              currentUser[0].userMail = this.authenticationService.currentUserValue.email;
              currentUser[0].userGivenName = this.authenticationService.currentUserValue.given_name;
              currentUser[0].userSurname = this.authenticationService.currentUserValue.family_name;
              this.CLHUBAPI.put('UserOrGroup', currentUser[0]).subscribe(result => {
              });
            }

            this.authenticationService.currentUserValue = this.currentUser;
            this.CLHUBAPI.post('FavoritePowerBIObject/filtered-list', {'UserOrGroupId': this.currentUser.userOrGroupId})
              .subscribe((FavoritesPowerBiObject) => {
                for (const favorite of FavoritesPowerBiObject) {
                  this.CLHUBAPI.get('PowerBiObject/' + favorite.powerBIObjectId).subscribe((powerBiObject) => {
                    if (powerBiObject.isReport) {
                      this.Reports.push(powerBiObject);
                    } else if (powerBiObject.isDashboard) {
                      this.Dashboards.push(powerBiObject);
                    }
                  });
                }
              });
          } else {
            // L'utilisateur n'existe pas, on le crée en bdd
            const newUser = new UserOrGroupModel();
            newUser.isGroup = false;
            newUser.isUser = true;
            newUser.azureObjectId = this.authenticationService.currentUserValue.azure_id;
            newUser.userGivenName = this.authenticationService.currentUserValue.given_name;
            newUser.userSurname = this.authenticationService.currentUserValue.family_name;
            newUser.userMail = this.authenticationService.currentUserValue.email;

            this.CLHUBAPI.post('UserOrGroup', newUser).subscribe(resultAdd => {
            });
          }
        });
    });
  }

  goToReport(report: any) {
    const idReport = report ? report.id : null;
    this.router.navigate(['bi/report/view', idReport]);
  }

  goToDashboard(dashboard: any) {
    const idDashboard = dashboard ? dashboard.id : null;
    this.router.navigate(['bi/dashboard/view', idDashboard]);
  }

  removeFromFavorite(powerBiObject: PowerBiObjectModel) {
    this.CLHUBAPI.post('FavoritePowerBIObject/filtered-list',
      {'PowerBIObjectId': powerBiObject.id,
              'UserOrGroupId': this.currentUser.userOrGroupId}
    ).subscribe((favoritePowerBiObject) => {
      this.CLHUBAPI.delete('FavoritePowerBIObject/' + favoritePowerBiObject[0].id, null).subscribe(idDeleted => {
        if (powerBiObject.isReport) {
          const index = this.Reports.indexOf(powerBiObject);
          if (index >= 0) {
            this.Reports.splice(index, 1);
          }
        } else {
          const index = this.Dashboards.indexOf(powerBiObject);
          if (index >= 0) {
            this.Dashboards.splice(index, 1);
          }
        }
      });
    });
  }

}
